/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TranslateItemRequest
 */
export interface TranslateItemRequest {
    /**
     * 
     * @type {string}
     * @memberof TranslateItemRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TranslateItemRequest
     */
    description?: string;
}

/**
 * Check if a given object implements the TranslateItemRequest interface.
 */
export function instanceOfTranslateItemRequest(value: object): value is TranslateItemRequest {
    return true;
}

export function TranslateItemRequestFromJSON(json: any): TranslateItemRequest {
    return TranslateItemRequestFromJSONTyped(json, false);
}

export function TranslateItemRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TranslateItemRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function TranslateItemRequestToJSON(json: any): TranslateItemRequest {
    return TranslateItemRequestToJSONTyped(json, false);
}

export function TranslateItemRequestToJSONTyped(value?: TranslateItemRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
    };
}

